export default __webpack_public_path__ + "static/media/english-to-finnish-mobile-1.d32fd4f8.png";